import { memo } from "react";
import BadgeIcon from '@mui/icons-material/Badge';
import {
    OnboardingApplicationStep,
    OnboardingApplication,
    ECommerceOnboardingApplication,
    onboardingApplicationStepAndFieldStatus
} from "consts/onboarding";
import {
    StepLabel,
    useApplicationDetailContext,
    type StepLabelProps
} from "ui/organizms/Onboarding/Applications/common";

const MediaAndComplianceCheckLabel = (props: Partial<StepLabelProps>) => {
    const { getStepData } = useApplicationDetailContext();

    const data = getStepData(ECommerceOnboardingApplication.MediaCompliance);

    return (
        <StepLabel
            to={`${OnboardingApplicationStep[OnboardingApplication.ECommerce].MediaAndComplianceCheck}`}
            Icon={BadgeIcon}
            {...onboardingApplicationStepAndFieldStatus.get(data.status)}
            {...props}
        >
            Media & Compliance Check
        </StepLabel>
    );

};

export default memo(MediaAndComplianceCheckLabel);
